'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ServiceRegistry = require('../ServiceRegistry');

var _ServiceRegistry2 = _interopRequireDefault(_ServiceRegistry);

var _ServiceAction = require('../ServiceAction');

var _ServiceAction2 = _interopRequireDefault(_ServiceAction);

var _Assert = require('../utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 
 * @ignore
 * @export
 * @class ServiceManager
 */
var ServiceManager = function () {

    /**
     * 
     * @ignore
     * @param {any} framework 
     * @memberof ServiceManager
     */
    function ServiceManager(framework) {
        (0, _classCallCheck3.default)(this, ServiceManager);

        _Assert2.default.notNull('framework', framework);
        this.framework = framework;
        this.services = new _map2.default();

        this.dispose = this.dispose.bind(this);

        this.add = this.add.bind(this);
        this.addWithProperties = this.addWithProperties.bind(this);
        this.findDefaultService = this.findDefaultService.bind(this);
        this.findServices = this.findServices.bind(this);
        this.remove = this.remove.bind(this);
        this.removeByOwner = this.removeByOwner.bind(this);
    }

    (0, _createClass3.default)(ServiceManager, [{
        key: 'dispose',
        value: function dispose() {
            this.services.clear();
        }
    }, {
        key: 'add',
        value: function add(serviceName, serviceInstance, serviceOwner) {
            return this.addWithProperties(serviceName, serviceInstance, serviceOwner);
        }
    }, {
        key: 'addWithProperties',
        value: function addWithProperties(serviceName, serviceInstance, serviceOwner, properties) {
            var serviceRegistry = new _ServiceRegistry2.default(serviceName, serviceInstance, serviceOwner, properties);
            if (!this.services.has(serviceRegistry.serviceName)) {
                this.services.set(serviceRegistry.serviceName, new _set2.default());
            }

            this.services.get(serviceRegistry.serviceName).add(serviceRegistry);
            this.framework.eventManager.fireServiceChanged(serviceName, _ServiceAction2.default.ADDED);
            return serviceRegistry;
        }

        /**
         * 获取匹配的服务
         * 
         * @param {string} name 服务名称
         * @param {any} properties 服务属性过滤
         * @returns {ServiceRegistry[]} 返回匹配的所有服务注册信息
         * @memberof ServiceManager
         */

    }, {
        key: 'findServices',
        value: function findServices(name, properties) {
            _Assert2.default.notEmpty('serviceName', name);

            if (!this.services.has(name)) {
                return [];
            }

            var serviceSet = this.services.get(name);
            var matchedServiceRegistries = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(serviceSet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var serviceRegistry = _step.value;

                    if (serviceRegistry.match(name, properties)) {
                        matchedServiceRegistries.push(serviceRegistry);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return matchedServiceRegistries;
        }
    }, {
        key: 'findDefaultService',
        value: function findDefaultService(name, properties) {
            _Assert2.default.notEmpty('serviceName', name);

            if (!this.services.has(name)) {
                return null;
            }

            var serviceSet = this.services.get(name);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(serviceSet), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var serviceRegistry = _step2.value;

                    if (serviceRegistry.match(name, properties)) {
                        return serviceRegistry.serviceInstance;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return null;
        }
    }, {
        key: 'remove',
        value: function remove(serviceRegistry) {
            _Assert2.default.notNull('serviceRegistry', serviceRegistry);
            if (this.services.has(serviceRegistry.serviceName)) {
                this.services.get(serviceRegistry.serviceName).remove(serviceRegistry);
                this.framework.eventManager.fireServiceChanged(serviceRegistry.serviceName, _ServiceAction2.default.REMOVED);
            }
        }
    }, {
        key: 'removeByOwner',
        value: function removeByOwner(owner) {
            _Assert2.default.notNull('serviceOwner', owner);

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.services), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var pair = _step3.value;

                    var serviceSet = pair[1];
                    var removedServices = [];
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = (0, _getIterator3.default)(serviceSet), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var serviceRegistry = _step4.value;

                            if (serviceRegistry.serviceOwner === owner) {
                                removedServices.push(serviceRegistry);
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = (0, _getIterator3.default)(removedServices), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var removedService = _step5.value;

                            serviceSet.delete(removedService);
                            this.framework.eventManager.fireServiceChanged(removedService.serviceName, _ServiceAction2.default.REMOVED);
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }]);
    return ServiceManager;
}();

exports.default = ServiceManager;
//# sourceMappingURL=ServiceManager.js.map